import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import AppConstants from '../../constants/AppConstants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private graphqlService: ApiService,
              private router: Router,
              private authService: AuthService) {
  }

  ngOnInit() {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/']);
    }
  }

  user = {
    email: '',
    password: ''
  };

  error: string = '';

  login() {
    const that = this;
    that.error = '';
    that.graphqlService.adminLogin(that.user).subscribe(res => {
      // Show error if mutation returns any error
      if (res.errors) {
        this.error = AppConstants.INVALID_LOGIN_DETAILS;
        return;
      }

      const token = res.data.adminLogin.token;
      if (token) {
        that.authService.login(token);

        const redirect = that.authService.getRedirect();
        if (redirect !== '') {
          that.router.navigate([redirect]);
        } else {
          that.router.navigate(['/']);
        }
      } else {
        return false;
      }
    }, err => {
      if (err.status === 400) {
        this.error = AppConstants.INVALID_LOGIN_DETAILS;
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/login/login.component.ts